module.exports = __webpack_public_path__ + "img/柚子9.93c6369b.png";